import { FC } from 'react';
import MinkaAllocateLedgerSearch from './MinkaAllocateLedgerSearch';
import UseMinkaAllocateLedgerSearch from './UseMinkaAllocateLedgerSearch';

const MinkaAllocateLedgerSearchContainer: FC = () => {
  return <MinkaAllocateLedgerSearch {...UseMinkaAllocateLedgerSearch()} />;
};

export default MinkaAllocateLedgerSearchContainer;
